export const ConversationErrors = {
  WEB_SAFE_AUTHORISATION_ERROR: 'WebSafeAuthorisationError',
  WEB_SAFE_NOT_FOUND_ERROR: 'WebSafeNotFoundError',
  WEB_SAFE_ERROR: 'WebSafeError',
};
